import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalModule, TabsModule, TooltipModule } from 'ngx-bootstrap';

import { JobMatchProfileOnConferenceComponent } from './job-match-profile-on-conference.component';
import { CandidateProfileModule } from 'src/app/pages/mission-control-page/candidateprofile-page/candidate-profile/candidate-profile.module';
import { JobProfileModule } from 'src/app/pages/mission-control-page/job-profile-page/job-profile/job-profile.module';
import { CandidateJobComparisonPageModule } from 'src/app/pages/mission-control-page/candidate-job-comparison-page/candidate-job-comparison-page.module';
import { SchedulesOnProfileModule } from 'src/app/shared/schedules-on-profile/schedules-on-profile.module';
import { FeedbackExecutionComponentModule } from 'src/app/shared/feedback-execution/feedback-execution-component.module';
import { NotesAndCommunicationModule } from 'src/app/shared/candidate-actions/notes-and-communication/notes-and-communication.module';
import { MoveJobMatchStepModule } from 'src/app/shared/job-match-actions/move-job-match-step/move-job-match-step.module';

@NgModule({
    declarations: [
        JobMatchProfileOnConferenceComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        TooltipModule.forRoot(),
        CandidateProfileModule,
        JobProfileModule,
        CandidateJobComparisonPageModule,
        SchedulesOnProfileModule,
        FeedbackExecutionComponentModule,
        NotesAndCommunicationModule,
        MoveJobMatchStepModule
    ],
    exports: [
        JobMatchProfileOnConferenceComponent
    ],
    entryComponents: [
        JobMatchProfileOnConferenceComponent
    ]
})
export class JobMatchProfileOnConferenceModule { }
